import { Box, Button, CircularProgress, Typography } from '@mui/material';
import React, { useState } from 'react';
import { FlexyForm, FormStructure } from '@europrocurement/flexy-form';
import { FieldValues, useForm } from 'react-hook-form';
import { FaOptionIcon, saveIcon } from '@europrocurement/l2d-icons';

type UpdateValideurFormProps = {
    currentIdentifier: string;
    onIdentifierChanged: (newIdentifier?: string) => void;
    onCancel: () => void;
};

type ValidatorIdentifierFormData = {
    identifier: string;
};

const UpdateValidatorIdentifier: React.FunctionComponent<UpdateValideurFormProps> = function ({
    currentIdentifier,
    onIdentifierChanged,
    onCancel,
}) {
    const [processing, setProcessing] = useState<boolean>(false);
    const formContext = useForm<FieldValues>({
        mode: 'onChange',
        defaultValues: {
            identifier: currentIdentifier,
        },
    });

    const handleFormSubmit = (formData: ValidatorIdentifierFormData) => {
        setProcessing(true);
        onIdentifierChanged(formData.identifier);
    };

    const formProps = {
        formContext,
        onSubmit: handleFormSubmit,
        submitButton: {
            displayed: false,
        },
    };

    const formStructure: FormStructure[] = [
        {
            type: 'text',
            name: 'identifier',
            inputlabel: 'Identifiant de la démarche',
            required: true,
            rules: {
                required: true,
            },
        },
    ];

    const submitBtnSx = {
        backgroundColor: 'primary.dark',
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: '0 10px',
    };

    return (
        <Box sx={{ minWidth: '500px' }}>
            <Typography variant="l2dh6">Modifier la démarche</Typography>
            <Box
                sx={{
                    padding: '26px 0',
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '10px',
                }}
            >
                <FlexyForm
                    formStructure={formStructure}
                    {...formProps}
                />
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    columnGap: '16px',
                }}
            >
                <Button
                    variant="text"
                    sx={{
                        padding: '16px 24px',
                        alignItems: 'center',
                        color: 'primary.dark',
                    }}
                    onClick={onCancel}
                    disabled={processing}
                >
                    Annuler
                </Button>
                <Button
                    variant="contained"
                    sx={submitBtnSx}
                    onClick={formContext.handleSubmit(handleFormSubmit)}
                    disabled={processing}
                >
                    {processing && (
                        <CircularProgress
                            color="inherit"
                            size="16px"
                        />
                    )}
                    {!processing && (
                        <FaOptionIcon
                            icon={saveIcon.props.icon}
                            sx={{ lineHeight: 0 }}
                        />
                    )}
                    Sauvegarder
                </Button>
            </Box>
        </Box>
    );
};

export default UpdateValidatorIdentifier;
